import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '../../lib/utils';

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

// Render through a Portal so the tooltip is mounted on <body> instead of
// inline next to its trigger. Inline rendering means any scrollable ancestor
// (in our case the sidebar's `overflow-y: auto`) clips the content — once an
// element scrolls on one axis, the browser silently treats `visible` on the
// other axis as `auto`, so even `overflow-x: visible` doesn't help. Portaling
// lifts the popper out of that clipping ancestor entirely.
const TooltipContent = React.forwardRef(
  ({ className, sideOffset = 6, collisionPadding = 12, ...props }, ref) => (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        className={cn(
          'z-[60] max-w-[320px] rounded-md border border-border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md whitespace-normal break-words animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          className
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  )
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
